import { ACTIONS, ActionType } from "actions/zendesk/types";
import produce, { Draft } from "immer";
import { LoadingState } from "types/api";
import { ZendeskKnowledgeState } from "./types";

export const initialState = {
    data: null,
    status: LoadingState.idle,
};

const zendeskKnowledge = produce((state: Draft<ZendeskKnowledgeState>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_ZENDESK_KNOWLEDGE_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.GET_ZENDESK_KNOWLEDGE_SUCCESS: {
            state.status = LoadingState.success;
            state.data = action.payload;
            break;
        }
        case ACTIONS.GET_ZENDESK_KNOWLEDGE_FAILURE:
            state.status = LoadingState.failure;
            break;
    }
}, initialState);

export default zendeskKnowledge;
